import { render, staticRenderFns } from "./DocumentDebtorFeeSetting.vue?vue&type=template&id=4d5f7a5f&scoped=true&"
import script from "./DocumentDebtorFeeSetting.vue?vue&type=script&lang=js&"
export * from "./DocumentDebtorFeeSetting.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDebtorFeeSetting.vue?vue&type=style&index=0&id=4d5f7a5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f7a5f",
  null
  
)

export default component.exports